import * as React from "react";
import { Loader } from "lucide-react";

import { cn } from "../../lib/utils";

/**
 * Spinner
 * A lightweight wrapper around lucide-react's `Loader` icon that applies
 * an `animate-spin` Tailwind class to provide a simple, accessible loading
 * indicator.
 */
export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  /**
   * Additional className(s) to merge with the default size & spin classes.
   */
  className?: string;
  /**
   * Icon size in pixels. Defaults to `16`.
   */
  size?: number;
}

export const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(
  ({ className, size = 16, ...props }, ref) => (
    <Loader
      ref={ref}
      className={cn("animate-spin", className)}
      width={size}
      height={size}
      aria-hidden="true"
      {...props}
    />
  )
);
Spinner.displayName = "Spinner";

export default Spinner; 